import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { useGroups } from '@/src/hooks/participant/useGroups'

/**
 * Hook для отображения уведомления при перемещении локального участника в другую группу
 */
export function useGroupChangeNotification() {
  const { t } = useTranslation()
  const { getCurrentUserGroupId, groups } = useGroups()
  const previousGroupId = useRef<string | null | undefined>(undefined)

  useEffect(() => {
    // Если это первое определение groupId (инициализация), просто сохраняем его
    if (previousGroupId.current === undefined) {
      previousGroupId.current = getCurrentUserGroupId
      return
    }

    // Если groupId изменился, показываем уведомление
    if (previousGroupId.current !== getCurrentUserGroupId && getCurrentUserGroupId !== null) {
      // Находим название группы
      const group = groups.find((g) => g.id === getCurrentUserGroupId)
      const groupName = group?.name || getCurrentUserGroupId

      toast.info(t('movedToGroup', { groupName }), {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        theme: 'dark',
      })
    }

    previousGroupId.current = getCurrentUserGroupId
  }, [getCurrentUserGroupId, groups, t])
}

